import { ComponentRef, Directive, Input } from '@angular/core';
import { type CalendarType } from '@modules/calendar-app/types/calendar-type';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import { CalendarCellContextMenuComponent } from '../components/calendar-cell-context-menu/calendar-cell-context-menu.component';

@Directive({
  selector: '[appCalendarCellContextMenu]',
  standalone: false,
})
export class CalendarCellContextMenuDirective extends ContextMenuDirective {
  // Inputs
  @Input() appCalendarCellContextMenu: Date;
  @Input() appCalendarCellContextMenuCalendarType: CalendarType;

  registerComponent() {
    return CalendarCellContextMenuComponent;
  }

  registerInstance(componentRef: ComponentRef<CalendarCellContextMenuComponent>) {
    componentRef.instance.date = this.appCalendarCellContextMenu;
    componentRef.instance.calendarType = this.appCalendarCellContextMenuCalendarType;
  }
}
